import { render, staticRenderFns } from "./barcodepay.vue?vue&type=template&id=06afd7d1&scoped=true&"
import script from "./barcodepay.vue?vue&type=script&lang=js&"
export * from "./barcodepay.vue?vue&type=script&lang=js&"
import style0 from "./barcodepay.vue?vue&type=style&index=0&id=06afd7d1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06afd7d1",
  null
  
)

export default component.exports